import React from 'react';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
import { media } from '../data/media';
import { useLanguage } from '../contexts/LanguageContext';
export function StorySection() {
  const {
    t
  } = useLanguage();
  return <section id="histoire" className="scroll-mt-32 bg-creme-dark py-24 md:py-32" data-id="element-273" data-mp="c1utanlvpd9s">
      <div className="mx-auto max-w-7xl px-6 md:px-12" data-id="element-274" data-mp="81b1lzk2r1v1">
        <div className="grid grid-cols-1 items-center gap-16 md:grid-cols-2 lg:gap-24" data-id="element-275" data-mp="14q0fleskzabq">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="border border-or/40 p-3" data-id="element-276" data-mp="zr5xkf2ftpso">
            <img src={media.hands} alt="Deux mains tenant un alfajor artisanal des Artisans Sucrés" className="aspect-[4/5] w-full object-cover" data-id="element-277" data-mp="qsln21716mfj" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-278" data-mp="1o7oemy95gk7s">
            <span className="mb-4 block font-sans text-xs uppercase tracking-[0.22em] text-caramel" data-id="element-279" data-mp="1f5yff6910gzg">
              {t.story.eyebrow}
            </span>
            <h2 className="mb-8 font-serif text-3xl leading-tight text-cacao-900 md:text-5xl" data-id="element-280" data-mp="1k7xjyjgi5jxz">
              {t.story.titleLead}{' '}
              <span className="italic text-or" data-id="element-281" data-mp="1a86mqa0k4qu7">{t.story.titleAccent}</span>
            </h2>

            <p className="mb-5 font-sans font-light text-cacao-700" data-id="element-282" data-mp="wh1sxojvesrs">
              {t.story.strugglesIntro}
            </p>
            <ul className="mb-8 space-y-3" data-id="element-283" data-mp="10iwvewdjfc75">
              {t.story.struggles.map(struggle => <li key={struggle} className="flex items-start gap-3 font-sans font-light text-cacao-700" data-id="element-284" data-mp="mjnflxt8uk3p">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-caramel text-caramel" data-id="element-285" data-mp="2t6cp1o8dbyvw">
                    <X size={11} strokeWidth={2.5} aria-hidden="true" data-id="element-286" data-mp="2of32wxm13dor" />
                  </span>
                  {struggle}
                </li>)}
            </ul>

            <div className="space-y-6 font-sans font-light leading-relaxed text-cacao-700" data-id="element-287" data-mp="2ffzhvo3awo7m">
              {t.story.paragraphs.map(paragraph => <p key={paragraph.slice(0, 32)} data-id="element-288" data-mp="3c3cpw2uza7hh">{paragraph}</p>)}
            </div>

            <p className="mt-8 border-l-2 border-caramel pl-5 font-serif text-lg italic text-cacao-900" data-id="element-289" data-mp="381r5zxk10sxs">
              {t.story.closing}
            </p>

            <div className="mt-12 flex items-center gap-6 border-t border-caramel/20 pt-12" data-id="element-290" data-mp="2y4mjtxq6kxgz">
              <div className="flex h-16 w-16 items-center justify-center rounded-full border border-caramel text-caramel" data-id="element-291" data-mp="1rpvmu546hws8">
                <span className="font-serif text-2xl italic" data-id="element-292" data-mp="1moxwh590lwfn">S</span>
              </div>
              <div data-id="element-293" data-mp="1cnwytnkia4hh">
                <p className="font-serif text-xl text-cacao-900" data-id="element-294" data-mp="1cof4tbwyzx2l">
                  {t.story.signatureName}
                </p>
                <p className="font-sans text-xs uppercase tracking-[0.18em] text-cacao-700" data-id="element-295" data-mp="1mkrwk48yg0up">
                  {t.story.signatureRole}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}